import { createAction, props } from '@ngrx/store';

export const loadReprocessPayments = createAction(
  '[ReprocessPayment] Load ReprocessPayments',
  props<{ request: { businessId: string; businessPaymentRunId: string } }>()
);

export const loadReprocessPaymentsSuccess = createAction(
  '[ReprocessPayment] Load ReprocessPayments Success',
  props<{ response: string }>()
);

export const loadReprocessPaymentsFailure = createAction(
  '[ReprocessPayment] Load ReprocessPayments Failure',
  props<{ error: Error | any }>()
);
